import { Component, Input, OnInit } from '@angular/core';
import { TransportDetailsLayoutConverter } from 'src/tmc-yard/common/components/tmp/transport-details-layout-converter.service';
import { TransportDetailLayout, TransportDetailMode } from 'src/tmc-yard/common/configuration/transport.configuration';
import { Transport } from 'src/tmc-yard/common/model/transport.model';
import { TransportDetailsLayoutService } from 'src/tmc-yard/components/transport-details/transport-details-layout.service';

@Component({
  selector: 'app-planned-assignment-details-list-entry',
  templateUrl: './planned-assignment-details-list-entry.component.html',
  styleUrls: ['./planned-assignment-details-list-entry.component.scss']
})
export class PlannedAssignmentDetailsListEntryComponent implements OnInit {

  TransportDetailMode = TransportDetailMode;
  layoutDefinition: TransportDetailLayout;

  @Input()
  transportDetails: Transport;

  constructor(
    private transportDetailsLayoutService: TransportDetailsLayoutService,
    transportDetailsLayoutConverter: TransportDetailsLayoutConverter
  ) {

    this.layoutDefinition = transportDetailsLayoutConverter.convert(
      this.transportDetailsLayoutService.createStationAssignmentTransportDetailsGridLayout()
    );

  }

  ngOnInit(): void {
  }

}
